// extracted by mini-css-extract-plugin
export default {"rtaSimpleForm_Results":"rta-simple-form--rtaSimpleForm_Results","rtaSimpleForm":"rta-simple-form--rtaSimpleForm"};